<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import { intlLocale } from 'dashboard/helper/intlLocale';

// Confirmação de exclusão de SLA que diz o tamanho do estrago antes do clique:
// as conversas ficam, mas o histórico de cumprimento sai dos relatórios.
// Caso: NaveNET (conta 29) — SLA "Comercial" em 40 mil conversas.
const props = defineProps({
  sla: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['confirm']);

const { t, locale } = useI18n();

const dialogRef = ref(null);

const conversationsCount = computed(() => props.sla?.conversations_count ?? 0);
const formattedCount = computed(() =>
  new Intl.NumberFormat(intlLocale(locale.value)).format(
    conversationsCount.value
  )
);

const open = () => dialogRef.value?.open();
const close = () => dialogRef.value?.close();

const handleConfirm = () => {
  emit('confirm', props.sla);
  close();
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    width="md"
    :title="t('SLA.DELETE.CONFIRM.TITLE', { name: sla?.name })"
    :cancel-button-label="t('SLA.DELETE.CONFIRM.NO')"
    :confirm-button-label="t('SLA.DELETE.CONFIRM.YES')"
    @confirm="handleConfirm"
  >
    <template #description>
      <div class="flex flex-col gap-3 text-sm text-n-slate-11 sm:w-96">
        <p v-if="conversationsCount > 0" class="mb-0 text-n-slate-12">
          {{
            t(
              'SLA.DELETE.CONFIRM.APPLIED_TO',
              { count: formattedCount },
              conversationsCount
            )
          }}
        </p>
        <p v-else class="mb-0 text-n-slate-12">
          {{ t('SLA.DELETE.CONFIRM.NOT_APPLIED') }}
        </p>
        <p v-if="conversationsCount > 0" class="mb-0">
          {{ t('SLA.DELETE.CONFIRM.CONVERSATIONS_KEPT') }}
        </p>
        <div
          v-if="conversationsCount > 0"
          class="flex gap-2 p-3 rounded-lg bg-n-amber-3 text-n-amber-11"
        >
          <span class="i-lucide-triangle-alert size-4 shrink-0 mt-0.5" />
          <div class="flex flex-col gap-1">
            <p class="mb-0 font-medium">
              {{ t('SLA.DELETE.CONFIRM.HISTORY_LOST') }}
            </p>
            <p class="mb-0">{{ t('SLA.DELETE.CONFIRM.KEEP_HISTORY_HINT') }}</p>
          </div>
        </div>
      </div>
    </template>
  </Dialog>
</template>
